import AuthService from './authService';
import OutsourcedJobLinkItem from '../Domain/OutsourcedJobLinkItem';
import SearchParams from '../Elements/SearchParams';
import OutsourcedJobLinkSearchParams from '../Contents/OutsourcedInvoicing/OutsourcedJobLink/OutsourcedJobLinkSearchParams';

export default class OutsourcedJobLinkService {
  static GetList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      OutsourcedJobLinkSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/OutsourcedJobLink/GetList/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    if (items === null) return [];
    return items.map((item) => new OutsourcedJobLinkItem(item));
  }

  static Delete(id) {
    return AuthService.getInstance().CallBackendFunctionDelete(`/api/OutsourcedJobLink/Delete/${id}`);
  }

  static MarkAsUninvoiceable(id) {
    return AuthService.getInstance().CallBackendFunctionPost(`/api/OutsourcedJobLink/MarkAsUninvoiceable/${id}`);
  }

  static MarkAsInvoiceable(id) {
    return AuthService.getInstance().CallBackendFunctionPost(`/api/OutsourcedJobLink/MarkAsInvoiceable/${id}`);
  }

  static CollectOutsourcedJobLinks() {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedJobLink/CollectOutsourcedJobLinks');
  }

  static AssignOutsourcedFees() {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedJobLink/AssignOutsourcedFee');
  }

  static ChangeFieldworkOffice(outsourcedJobLinkIds, newFieldworkOfficeId, allItemsSelected, searchItem) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedJobLink/ChangeFieldworkOffice', {
      outsourcedJobLinkIds,
      newFieldworkOfficeId,
      allItemsInTheSearchSetAreSelected: allItemsSelected ?? false,
      searchItem: searchItem ?? null,
    });
  }

  static RemoveFee(outsourcedJobLinkIds, allItemsSelected, searchItem) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedJobLink/RemoveFee', {
      outsourcedJobLinkIds,
      allItemsInTheSearchSetAreSelected: allItemsSelected ?? false,
      searchItem: searchItem ?? null,
    });
  }

  static Approve(outsourcedJobLinkIds, allItemsSelected, searchItem, newStatus) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedJobLink/Approve', {
      outsourcedJobLinkIds,
      allItemsInTheSearchSetAreSelected: allItemsSelected ?? false,
      searchItem: searchItem ?? null,
      newStatus,
    });
  }
}
